var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendedSkus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7335 3.13149C25.2448 1.51676 23.2019 0.627441 20.9809 0.627441C19.3208 0.627441 17.8004 1.15232 16.4619 2.18735C15.7865 2.70975 15.1745 3.34899 14.635 4.09496C14.0956 3.34916 13.4835 2.70975 12.8079 2.18735C11.4696 1.15232 9.94921 0.627441 8.28903 0.627441C6.06804 0.627441 4.025 1.51676 2.53621 3.13149C1.06522 4.72734 0.254883 6.90756 0.254883 9.27073C0.254883 11.703 1.16133 13.9295 3.10737 16.2778C4.84826 18.3783 7.35034 20.5107 10.2478 22.9799C11.2372 23.8231 12.3587 24.7789 13.5232 25.797C13.8308 26.0665 14.226 26.215 14.635 26.2148C15.0442 26.2148 15.4391 26.0665 15.7464 25.7975C16.9108 24.7791 18.033 23.8229 19.0228 22.9792C21.9199 20.5104 24.4219 18.3783 26.1628 16.2775C28.1089 13.9296 29.0151 11.703 29.0151 9.2705C29.0151 6.90756 28.2048 4.72734 26.7335 3.13149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedSkus);
export default __webpack_public_path__ + "static/media/recommended_skus.fa024dd79d3eedb426b90151534c8dcd.svg";
export { ForwardRef as ReactComponent };